<div class="card border-0 mb-5" rt="machine-card" #card>
  <div class="card-image" [class.show-extra-info]="showExtraInfo">
    <swiper [config]="imageSwipeConfig" *ngIf="cardImages.length > 0 && !imageLoadError">
      <div *ngFor="let image of cardImages; let i = index">
        <a
          *ngIf="shouldShowImage(i)"
          rt="machine-card-img"
          [routerLink]="[machineDetailsUrl]"
          [queryParams]="{ id: machine.id }"
          [commonEventTracker]="MarketTrackingEvents.SearchResult.Click"
          [properties]="{ inventoryId: machine.id }"
          (click)="$event.stopPropagation()"
        >
          <img 
            class="card-img-top" 
            *ngIf="cardImages.length == 1" 
            [class.blur]="showExtraInfo" 
            [src]="baseImagePath + image" 
            [alt]="machine.make + ' ' + machine.model"
            (error)="onImageError(i)"
          />
          <img
            class="card-img-top swiper-lazy"
            *ngIf="cardImages.length != 1"
            [class.blur]="showExtraInfo"
            [attr.data-src]="baseImagePath + image"
            [attr.alt]="machine.make + ' ' + machine.model"
            (error)="onImageError(i)"
          />
        </a>
      </div>
    </swiper>

    <ng-container *ngIf="imageLoadError || machine.images?.length == 0">
      <a
        rt="machine-card-img"
        [routerLink]="[machineDetailsUrl]"
        [queryParams]="{ id: machine.id }"
        [commonEventTracker]="MarketTrackingEvents.SearchResult.Click"
        [properties]="{ inventoryId: machine.id }"
        [state]="filteredAttachments"
        (click)="$event.stopPropagation()"
      >
        <div class="card-img-top d-flex align-items-center justify-content-center text-center p-4" style="min-height: 300px; background-color: #f5f5f5">
          <p class="font-weight-light text-muted mb-0">We are sorry, machine images are currently unavailable. Rest assured all listings are 100% accurate.</p>
        </div>
      </a>
    </ng-container>

    <div class="share-icon-main-container cursor-pointer" *ngIf="!showExtraInfo" (click)="$event.stopPropagation(); share()">
      <div class="icon-share-container">
        <i class="icon-share text-white"></i>
      </div>
    </div>

    <div class="top-owner-container" [class.extra-blur]="showExtraInfo" *ngIf="machine.isTopOwner">
      <common-top-owner [showTopOwner]="machine.isTopOwner"></common-top-owner>
    </div>

    <div class="one-day-shipping-container" [class.extra-blur]="showExtraInfo" *ngIf="machine.inventoryGroupId && !machineInCart">
      <common-top-owner [showTopOwner]="true" icon="icon-truck-fill" theme="light" text="1 day shipping"></common-top-owner>
    </div>

    <!-- below had a has stock photos check  -->
    <!--    *ngIf="machineInCart || hasStockPhotos" -->
    <div
      class="machine-in-cart text-white px-3 py-1 font-weight-light w-100 d-flex align-items-center"
      style="z-index: 2"
      [class.blur]="showExtraInfo"
      [class.cursor-pointer]="hasStockPhotos && !machineInCart"
      *ngIf="machineInCart"
      (click)="hasStockPhotos && !machineInCart && showStockPhotoInfo()"
    >
      <ng-container *ngIf="machineInCart"><i class="icon-checkmark mr-2"></i> Added to cart</ng-container>
      <!-- <div class="d-flex align-items-center cursor-pointer" *ngIf="hasStockPhotos && !machineInCart"><i class="icon-alert mr-2"></i> Stock photo</div> -->
    </div>
  </div>
  <!-- start of extra info -->
  <div class="extra-info br-5 pt-3 t px-3 text-white w-100" [@fadeInOut] [style.height]="extraInfoHeight" *ngIf="showExtraInfo">
    <div class="info-icon-main-container cursor-pointer" (click)="hideExtraInfo()">
      <div class="icon-info-container">
        <i class="icon-cancel text-white fs-26"></i>
      </div>
    </div>
    <swiper [config]="extraInfoConfig" [(index)]="extraInfoIndex">
      <!-- first slide -->
      <div>
        <div class="fs-18 mb-3">Pricing Options</div>
        <p class="fs-14 font-weight-light">The following pricing options are available for this equipment.</p>
        <div class="d-flex justify-content-around font-weight-light mt-1">
          <div class="text-center" *ngFor="let rateSchedule of machine.rateSchedules | slice: 1; last as isLast; index as i">
            <p class="mb-0" *ngIf="rateSchedule.discount == 0">${{ rateSchedule.cost | thousandSuffix: 1 }}</p>
            <p class="mb-0" *ngIf="rateSchedule.discount != 0">${{ rateSchedule.cost / (rateSchedule.numDays / 28) | thousandSuffix: 1 }}</p>

            <ng-container [ngSwitch]="i">
              <p class="text-white mb-0 font-weight-light fs-13" *ngSwitchCase="0">Weekly</p>
              <p class="text-white mb-0 font-weight-light fs-13" *ngSwitchCase="1">Monthly</p>
              <p class="text-white mb-0 font-weight-light fs-13" *ngSwitchCase="2">3+ Mos</p>
              <p class="text-white mb-0 font-weight-light fs-13" *ngSwitchCase="3">6+ Mos</p>
            </ng-container>
            <span class="badge badge-pill badge-success p-1 font-weight-light" *ngIf="rateSchedule.discount != 0">{{ rateSchedule.discountPercent }}% off</span>
          </div>
        </div>
      </div>
      <!-- second slide -->
      <!-- <div *ngIf="hasStockPhotos">
        <div class="fs-18 mb-3">Stock photo</div>
        <p class="fs-14 font-weight-light">This listing contains a stock photo. All other information, including specs and pricing, is accurate.</p>
        <p class="fs-14 font-weight-light">Photos will be made available on order placement. Order cancellations are always free.</p>
        <p class="fs-14 font-weight-light">Call us at (866) 455-8531 for any questions.</p>
      </div> -->
      <!-- third slide -->
      <div class="px-2" *ngIf="machine.rpoEnabled">
        <common-machine-rpo-table [machine]="machine" fontClass="fs-14"></common-machine-rpo-table>
      </div>
    </swiper>
  </div>
  <!-- end of extra info -->
  <div class="text-info"></div>
  <div class="px-2" [class.blur]="showExtraInfo">
    <div class="d-flex align-items-start machine-info-row">
      <div class="mt-2 machine-details">
        <div class="machine-heading">
          <p class="teko machine-title mb-0">{{ machine.make }} {{ machine.model }}</p>
          <p class="font-weight-light machine-subtitle mb-0">{{ machine.year }} {{ machine.primaryType }}</p>
        </div>
        <p class="font-weight-light fs-13 machine-meta mb-0">
          <ng-container *ngIf="(machine.usageAbbreviation || 'hrs') !== 'none'">
            {{ machine.usage | number: "1.0-0" }} {{ machine.usageAbbreviation || "hrs" }} <span class="mx-1">|</span>
          </ng-container>

          {{ machine?.location | location: "cityState":false }}
          <ng-container *ngIf="machine.distanceFromUser">
            <span class="mx-1 d-none d-xl-inline">|</span>
            <span class="d-none d-xl-inline">{{ machine.distanceFromUser }} miles away</span>
          </ng-container>
        </p>
        <p class="d-xl-none font-weight-light fs-13 machine-meta mb-0" *ngIf="machine.distanceFromUser">{{ machine.distanceFromUser }} miles away</p>
        <!-- <div class="d-inline-flex" *ngIf="machine.inventoryGroupId == ''; else freeTransport"> -->
        <div class="d-inline-flex flex-wrap">
          <div
            class="alert alert-success fs-13 p-1 font-weight-light d-flex align-items-center mb-1 mr-2"
            role="alert"
            *ngIf="machine.recentCancellations == 0"
          >
            <i class="icon-insurance mr-1"></i> {{ machine.recentCancellations }} cancels in the past 3 months
          </div>

          <div
            class="alert alert-warning fs-13 p-1 font-weight-light d-flex align-items-center mb-1 mr-2"
            role="alert"
            *ngIf="machine.recentCancellations == 1"
          >
            <i class="icon-notification1 mr-1"></i> {{ machine.recentCancellations }} cancel in the past 3 months
          </div>

          <div class="alert alert-danger fs-13 p-1 font-weight-light d-flex align-items-center mb-1 mr-2" role="alert" *ngIf="machine.recentCancellations > 1">
            <i class="icon-notification1 mr-1"></i> {{ machine.recentCancellations }} cancels in the past 3 months
          </div>

          <div
            class="alert alert-warning financing-badge fs-13 p-1 font-weight-light d-flex align-items-center mb-1 cursor-pointer"
            role="alert"
            *ngIf="machine.buyItNowEnabled || machine.rpoEnabled"
            (click)="navigateToFinancing($event)"
          >
            <i class="icon-earnings mr-1"></i> Financing Available
          </div>
        </div>
        <!-- <ng-template #freeTransport>
          <div class="d-inline-flex align-items-center text-green my-2">
            <div class="text-green font-weight-light">Free 1-2 day delivery</div>
          </div>
        </ng-template> -->
      </div>
      <div class="ml-auto font-weight-light">
        <div class="d-flex flex-column align-items-end">
          <!-- <span class="mb-2 text-green cursor-pointer" (click)="showPricingOptions()"
            ><u>${{ machine.rentalRate | thousandSuffix: 1 }} per month</u></span
          > -->
          <span class="badge badge-success p-1 font-weight-light d-flex cursor-pointer mb-1 mt-2" (click)="$event.stopPropagation(); showRpoInfo()" *ngIf="machine.rpoEnabled"
            ><i class="icon-info mr-1"></i> Rent to Own Available</span
          >
        </div>
      </div>
    </div>

    <div class="mt-1" *ngIf="machine.relatedAttachments.length > 0">
      <span
        *ngFor="let attachment of machine.relatedAttachments"
        class="badge badge-pill fs-13 p-1 font-weight-light mr-2 mb-1 px-2"
        [ngClass]="{ 'badge-secondary': attachment.selected, 'badge-outline-secondary': !attachment.selected }"
        ><i class="icon-checkmark mr-2" *ngIf="attachment.selected" style="color: #f0b823"></i>{{ attachment.displayName }}
      </span>
    </div>

    <div class="d-flex justify-content-between" *ngIf="listingPrice.showRentalRates">
      <div class="d-flex flex-column price-column" *ngIf="listingPrice.weekly != null">
        <span class="font-weight-light fs-14">Weekly</span>
        <span class="text-success fs-40 teko">{{ listingPrice.weekly | currency: "USD":"symbol":"1.0-0" }}</span>
      </div>
      <div class="d-flex flex-column price-column" *ngIf="listingPrice.monthly != null">
        <span class="font-weight-light fs-14">Monthly</span>
        <span class="text-success fs-40 teko">{{ listingPrice.monthly | currency: "USD":"symbol":"1.0-0" }}</span>
      </div>
    </div>

    <div class="alert alert-warning fs-14 p-2 font-weight-light d-flex align-items-center mb-3 mt-3" role="alert" *ngIf="machine.status === 'OnRent' && machine.buyItNowEnabled">
      <i class="icon-notification1 mr-2"></i> Currently Rented - Purchase Only
    </div>

    <div class="d-flex justify-content-center mt-3">
        <div [class.w-50]="machine.status !== 'OnRent' && machine.status !== 'Reserved'" [class.w-100]="machine.status === 'OnRent' || machine.status === 'Reserved'" class="d-flex">
          <a
            rt="machine-card-view-details"
            class="btn btn-outline-dark bg-white text-dark flex-fill btn-add-to-cart d-flex justify-content-center align-items-center py-0"
            [class.mr-1]="machine.status !== 'OnRent' && machine.status !== 'Reserved'"
            [routerLink]="[machineDetailsUrl]"
            [queryParams]="{ id: machine.id }"
            [commonEventTracker]="MarketTrackingEvents.SearchResult.Click"
            [properties]="{ inventoryId: machine.id }"
            [state]="filteredAttachments"
            ><div class="fs-24 teko">Details</div>
          </a>
        </div>

        <button class="btn btn-secondary btn-add-to-cart ml-1 w-50" (click)="addToCart()" *ngIf="machine.status !== 'OnRent' && machine.status !== 'Reserved'">
          {{ machineInCart ? "Edit" : "Add to Cart" }}
        </button>

        <!-- <button *ngIf="machine.buyItNowEnabled" class="d-none d-md-flex btn btn-success btn-add-to-cart ml-1 w-50 align-items-center justify-content-center py-0">
          <i class="icon-earnings fs-30 text-white mr-2"></i>
          <div class="fs-24 teko">Buy it Now</div>
        </button> -->
      </div>

      <a
        target="_blank"
        [href]="financingUrl()"
        *ngIf="machine.buyItNowEnabled"
        class="d-flex btn btn-outline-dark btn-add-to-cart align-items-center justify-content-center py-0 w-100 mt-2"
      >
        <i class="icon-earnings fs-30 text-primary mr-2"></i>
        <div class="fs-24 teko">
          <ng-container *ngIf="listingPrice.buyItNow === 'price'">Buy it Now for {{ listingPrice.buyItNowPrice | currency: "USD":"symbol":"1.0-0" }}</ng-container>
          <ng-container *ngIf="listingPrice.buyItNow === 'on-request'">Buy It Now — Price on Request</ng-container>
          <ng-container *ngIf="listingPrice.buyItNow === 'unlabeled'">Buy it Now</ng-container>
        </div>
      </a>
  </div>
</div>
